"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgClipboardAddOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M21 5a3.66 3.66 0 00-.86-2.58A5.33 5.33 0 0016 1a5.33 5.33 0 00-4.14 1.42A3.67 3.67 0 0011 5H6v25h20V5zm-8 .18c0-1 .17-1.22.37-1.45A3.67 3.67 0 0116 3a3.66 3.66 0 012.62.73c.2.24.38.44.38 1.45V8h-6zM24 28H8V7h3v3h10V7h3z" }),
        React.createElement("path", { d: "M17 14h-2v4h-4v2h4v4h2v-4h4v-2h-4v-4z" })));
}
exports.default = SvgClipboardAddOutline;
//# sourceMappingURL=ClipboardAddOutline.js.map